export default __webpack_public_path__ + "assets/front/scss/formulaire.0e31fdc8c4fed2ef3d30ff52772b0a86.css";